import { getExams } from "./firebase";

export function getExamAction() {
  return async dispatch => {
    dispatch({
      type: "GET_EXAMS"
    });
    try {
      getExams(exams => {
        dispatch({ type: "GET_EXAM_SUCCESS", payload: exams });
        dispatch({ type: "EXAM_LOADING_COMPLETE" });
      });
    } catch (e) {
      dispatch({ type: "GET_EXAM_ERROR" });
    }
  };
}
